import { render, staticRenderFns } from "./Vales.vue?vue&type=template&id=140b74ce&scoped=true"
import script from "./Vales.vue?vue&type=script&lang=js"
export * from "./Vales.vue?vue&type=script&lang=js"
import style0 from "./Vales.vue?vue&type=style&index=0&id=140b74ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b74ce",
  null
  
)

export default component.exports